import { useEffect, useState } from "react";
import { Trash2, Reply } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const when = (iso) => new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

const Message = ({ m, onToggle, onDelete }) => (
  <article className={`px-6 py-5 border-b border-[var(--rule)] last:border-b-0 ${m.read ? "" : "bg-[#FFFDF7]"}`} data-testid={`message-row-${m.id}`}>
    <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
      {!m.read && <span className="w-2 h-2 rounded-full bg-[var(--accent)] self-center" data-testid={`message-unread-dot-${m.id}`} />}
      <span className="font-ui text-sm font-semibold">{m.name}</span>
      <span className="font-ui text-sm text-[var(--ink-2)]">{m.email}</span>
      <span className="ml-auto font-ui text-xs text-[var(--ink-3)]">{when(m.created_at)}</span>
    </div>
    <p className="mt-3 whitespace-pre-wrap leading-relaxed text-[var(--ink)]">{m.message}</p>
    <div className="mt-4 flex items-center gap-4 font-ui text-xs">
      <a href={`mailto:${m.email}?subject=${encodeURIComponent("Re: your message to ukdiscovered")}`} className="inline-flex items-center gap-1 link-quiet" data-testid={`message-reply-${m.id}`}><Reply size={13} /> Reply by email</a>
      <button onClick={() => onToggle(m)} className="link-quiet" data-testid={`message-toggle-read-${m.id}`}>{m.read ? "Mark as unread" : "Mark as read"}</button>
      <button onClick={() => onDelete(m)} className="inline-flex items-center gap-1 text-[var(--ink-3)] hover:text-[var(--accent)]" data-testid={`message-delete-${m.id}`}><Trash2 size={13} /> Delete</button>
    </div>
  </article>
);

export default function AdminMessages() {
  const [messages, setMessages] = useState(null);
  const load = () => api.get("/admin/messages").then((r) => setMessages(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (m) => { await api.patch(`/admin/messages/${m.id}`, { read: !m.read }); load(); };
  const remove = async (m) => {
    if (!window.confirm("Delete this message?")) return;
    await api.delete(`/admin/messages/${m.id}`);
    toast.success("Message deleted");
    load();
  };

  if (!messages) return <p className="meta">Loading</p>;
  return (
    <div data-testid="admin-messages-page">
      <p className="meta">Private inbox</p>
      <h1 className="font-display text-4xl font-bold mt-1">Messages</h1>
      <div className="mt-8 bg-white border border-[var(--rule)]" data-testid="admin-messages-list">
        {messages.length === 0 && <p className="p-6 italic text-[var(--ink-3)]">No messages yet. They'll appear here when readers use the contact page.</p>}
        {messages.map((m) => <Message key={m.id} m={m} onToggle={toggle} onDelete={remove} />)}
      </div>
    </div>
  );
}
